import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";

const iconColor = "#ff3f6c";

export default function BigSpinner() {
  return (
    <Row
      className="justify-content-center align-items-center mt-4"
      style={{ height: "80vh" }}
    >
      <Col xs="auto" className="align-self-center">
        <Spinner
          animation="border"
          role="status"
          style={{ width: "5em", height: "5em", color: iconColor }}
        />
      </Col>
    </Row>
  );
}
